import React from 'react';
import { 
  RocketLaunchIcon, 
  LightBulbIcon, 
  WrenchScrewdriverIcon, 
  CogIcon, 
  PaintBrushIcon, 
  SpeakerWaveIcon,
  ArrowPathIcon,
  LinkIcon
} from '@heroicons/react/24/outline';
import { Link } from 'react-router-dom';
import PlaybookSection from '../../../components/playbooks/PlaybookSection';
import StageCards from '../../../components/playbooks/StageCards';
import { getPlaybookById } from '../../../data/playbookTaxonomy';

// Stage icons mapping
const stageIcons = {
  'stage-1': <LightBulbIcon className="h-6 w-6" />,
  'stage-2': <WrenchScrewdriverIcon className="h-6 w-6" />,
  'stage-3': <CogIcon className="h-6 w-6" />,
  'stage-4': <PaintBrushIcon className="h-6 w-6" />,
  'stage-5': <SpeakerWaveIcon className="h-6 w-6" />,
  'stage-6': <ArrowPathIcon className="h-6 w-6" />
};

const PerformanceFrameworkHowToExecute = () => {
  // Get stage sections from the taxonomy
  const playbook = getPlaybookById('how-to-build-launch-embed-performance');
  const stageSections = playbook?.sections.filter(section => section.id.startsWith('stage-')) || [];

  return (
    <div className="space-y-8">
      <PlaybookSection title="How To Execute" icon={<RocketLaunchIcon className="h-7 w-7 text-primary-light" />} heading>
        <div className="mb-8 space-y-4">
          <p className="text-gray-300 text-lg">
            Building an effective performance framework requires a systematic approach that balances thoroughness with practicality. 
            This guide takes you through six essential stages, from establishing your performance philosophy to embedding continuous 
            performance practices into your organization's DNA.
          </p>
          <p className="text-gray-300 text-lg">
            Each stage builds on the previous one, ensuring you have solid foundations before moving forward. While some stages may 
            take longer than others depending on your organizational context, resist the urge to skip ahead - the building blocks are 
            essential for long-term success.
          </p>
        </div>

        <StageCards 
          stages={stageSections}
          icons={stageIcons}
          playbookId="how-to-build-launch-embed-performance"
          introText="Our step-by-step approach to building, launching, and embedding performance frameworks that actually work. Each stage is designed to build on the previous one, ensuring you have solid foundations for sustainable performance practices."
        />


      </PlaybookSection>
    </div>
  );
};

export default PerformanceFrameworkHowToExecute; 